import React from 'react'
import { Flex, Heading } from '@theme-ui/components'
import ContactDetails from '../../../General/ContactDetails'
import CloudinaryImage from '../../../General/CloudinaryImage'
import MultiButtons from '../../../General/MultiButtons/MultiButtonsV1'
import Copyright from '../../../General/Copyright'
import GonationLogoPowered from '../../../General/GonationLogoPowered'
import SocialIcons from '../../../General/SocialIcons/SocialIconsV2'
import LocationSwitcher from '../../../LocationSwitchers/v1/LocationSwitcher'
import PopUp from '../../../PopUps/v1/PopUp.js'
import combineSocialLinks from '../../../../helpers/combineSocialLinks'

export default function Index(props) {
  // === Destructing ===
  const { businessData, configData, locations, navLinks, options, variantName, locationIndex, isMultiLocationSite } =
    props
  const {
    avatar: { imageBaseUrl, imagePrefix },
    name,
    street,
    city,
    state,
    zip,
    links,
    slug
  } = businessData

  const {
    images,
    ctaName,
    title,
    titles,
    ctaLinks,
    popUpContentBoxes,
    texts,
    quotes,
    containerStyles,
    // hideNavLinks,
    linkedin,
    pinterest,
    email
  } = options

  //=== Data Transformations ===
  const variant = variantName ? variantName : 'footerV5'
  const styles = containerStyles ? JSON.parse(containerStyles) : {}
  const configuredSocialLinks =
    linkedin || pinterest ? combineSocialLinks(links, linkedin?.[locationIndex], pinterest) : links

  return (
    <Flex sx={styles} variant={`${variant}.container`} className="container footer">
      <Flex variant={`${variant}.row`} className="row">
        <Flex variant={`${variant}.columnLogo`} className="column logo columnLogo">
          <CloudinaryImage variant={`${variant}.logo`} imageBaseUrl={imageBaseUrl} imagePrefix={imagePrefix} />

          {quotes && (
            <Flex variant={`${variant}.quote`} className="quote">
              {quotes}
            </Flex>
          )}

          <Flex variant={`${variant}.ctasContainer`} className="ctasContainer">
            {isMultiLocationSite && <LocationSwitcher businessData={businessData} locations={locations} />}

            {popUpContentBoxes && (
              <Flex variant={`${variant}.popUpContentBoxesContainer`} className="popUpContentBoxesContainer">
                <PopUp
                  variant={`${variant}.popUpContentBoxes`}
                  {...props}
                  images={images}
                  ctaName={ctaName}
                  title={title}
                  titles={titles}
                  ctaLinks={ctaLinks}
                  texts={texts}
                />
              </Flex>
            )}
          </Flex>
        </Flex>

        <Flex variant={`${variant}.columnNav`} className="column columnNav">
          <Heading
            as="h5"
            variant={`${variant}.footerSectionHeading`}
            className="footerSectionHeading footerNavigationHeading"
          >
            Explore
          </Heading>
          <MultiButtons isMultiLocationSite={isMultiLocationSite} links={navLinks} city={city} />
        </Flex>

        <Flex variant={`${variant}.columnContact`} className="column columnContact">
          <Heading
            as="h5"
            variant={`${variant}.footerSectionHeading`}
            className="footerSectionHeading footerContactHeading"
          >
            Contact
          </Heading>
          <ContactDetails
            phone={businessData.phone}
            address={{ name, street, city, state, zip }}
            alternativeGoogleMapLink={configData.alternativeGoogleMapLink}
            email={email?.[locationIndex] ?? links?.email ?? ''}
          />
        </Flex>

        <Flex variant={`${variant}.columnSocial`} className="column columnSocial">
          <Heading
            as="h5"
            variant={`${variant}.footerSectionHeading`}
            className="footerSectionHeading footerSocialHeading"
          >
            Social
          </Heading>
          <SocialIcons slug={slug} links={configuredSocialLinks} variantName={variantName} />
        </Flex>
      </Flex>

      <Flex variant={`${variant}.bottomBar`} className="bottomBar">
        <Copyright name={name} />
        <GonationLogoPowered />
      </Flex>
    </Flex>
  )
}
